import qs from 'query-string';
import { apiConfig } from '../api-config';

export interface GetAddressUserParams {
  tokenKey: string;
  cdUser: number;
}

export const getAddressUser = async (params: GetAddressUserParams) => {
  const query = qs.stringify(params);

  return apiConfig
    .get(`/api/Agent/BillingAddressByCdUser?${query}`)
    .then((resp) => resp.data.objectResult || {})
    .catch((err) => ({ hasErrors: true, err: err.message }));
};
